export default {"src":"/_next/static/media/chatBubbleWithDots_24.ddca8ab4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};